import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import type { LayoutTemplateDef, LayoutZoneDef } from './layoutFormat';
import { gridStyle, zoneName, zoneStyle } from './layoutFormat';

type LayoutPreviewGridProps = {
  def: LayoutTemplateDef;
  /** Label per zone key (and ticker). */
  labels?: Record<string, string>;
  big?: boolean;
};

function zoneLabel(
  zone: LayoutZoneDef,
  labels: Record<string, string> | undefined,
  big: boolean,
  t: TFunction<'layouts'>,
) {
  if (zone.ticker) {
    return labels?.Ticker || (big ? t('preview.tickerPlaceholder') : t('preview.tickerShort'));
  }
  const name = zoneName(zone.key);
  return labels?.[zone.key] || (big ? t('preview.emptyZone', { zone: name }) : name);
}

/** Zones are physical screen regions, so the grid never mirrors in right-to-left languages. */
export function LayoutPreviewGrid({ def, labels, big = false }: LayoutPreviewGridProps) {
  const { t } = useTranslation('layouts');
  return (
    <span style={gridStyle(def)} dir="ltr">
      {def.zones.map((zone) => (
        <span key={zone.key} style={zoneStyle(zone, big)}>
          {zoneLabel(zone, labels, big, t)}
        </span>
      ))}
    </span>
  );
}
